"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromAscii = exports.toAscii = void 0;
function toAscii(buf, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = Infinity; }
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7f);
    }
    return ret;
}
exports.toAscii = toAscii;
function fromAscii(str) {
    var len = str.length;
    var byteArray = new Array(len);
    for (var i = 0; i < str.length; ++i) {
        byteArray[i] = str.charCodeAt(i) & 0xff;
    }
    return new Uint8Array(byteArray);
}
exports.fromAscii = fromAscii;
